import { exitBasicPlan } from "./exit-basic-plan"
import { explorePremium } from "./explore-premium"
import { livesUsed } from "./lives-used"
import { seePlans } from "./see-plans"
import { startBasicPlan } from "./start-basic-plan"

export enum PAYMENT_EVENTS {
  EXPLORE_PREMIUM = "User press 'explore premium' from end free trial modal",
  SEE_PLANS = "User press see plans from 'Get tich premium' modal",
  LIVES_USED = "User reached 0 lives for the first time",
  START_BASIC_PLAN = "User clicks on 'Start basic plan' button",
  EXIT_BASIC_PLAN = "User completes basic plan payment",
}

export const payments = {
  explorePremium,
  seePlans,
  livesUsed,
  startBasicPlan,
  exitBasicPlan,
}
